import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./styles";
import classNames from "classnames";
import { Close as CloseIcon, Label } from "@material-ui/icons";

import {
	Fab,
	IconButton,
	Typography,
	withStyles
} from "@material-ui/core";

import {
	Add as AddIcon,
	Remove as RemoveIcon,
	FirstPage as PrevPage,
	LastPage as NextPage
} from "@material-ui/icons";

class Toolbar extends Component {

	constructor(props) {
		super(props);
		this.state = {
			scale: 0,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.state.scale !== nextState.scale) {
			return true;
		}
		return false;
	}

	render() {
		const { classes, onZoomIn, onZoomOut, onClose } = this.props;
		return (
			<div className={classes.toolbar}>
				<Fab
					className={classes.zoomOut}
					onClick={(event) => onZoomOut(event)}
				>
					<RemoveIcon />
				</Fab>
				<Fab
					className={classes.zoomIn}
					onClick={(event) => onZoomIn(event)}
				>
					<AddIcon />
				</Fab>

				<div className={classes.backActions}>
					<Typography>{"RETOUR"}</Typography>
					<Fab className={classes.btnBack} onClick={()=>{
						onClose();
					}}>
						<CloseIcon/>
					</Fab>
				</div>
				

			</div>
		);
	}

}

Toolbar.propTypes = {
	classes: PropTypes.object.isRequired,
	onZoomIn: PropTypes.func.isRequired,
	onZoomOut: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired
};

export default withStyles(styles)(Toolbar);
